import Descriptor from "./rapidstor/entities/Descriptor";

export const uniqueValues = (nums: (string | number)[]) => [...new Set(nums)];

// Takes an array of Descriptors and returns an array of unique sizes for populating the slider
export const getUnitSizes = (units: Descriptor[]) => {
  let areaArr: (number | string)[] = [];
  units.map((unit) => {
    areaArr.push(unit.area);
  });
  areaArr = uniqueValues(areaArr);
  return areaArr.sort((a, b) => {
    return parseFloat(a.toString()) - parseFloat(b.toString());
  });
};

export const monthlyToWeekly = (value: number) => {
  if (!value) {
    return 0;
  }
  return (value / 4).toLocaleString("en-GB", {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    trailingZeroDisplay: "stripIfInteger",
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  });
};

export const addVat = (value: number | undefined, rate: number) => {
  if (!value) {
    return 0;
  }
  return Math.round((value + value * rate) * 100) / 100;
};

export const formatCurrency = (value: number | undefined | string) => {
  if (!value) {
    value = 0;
  }
  return value.toLocaleString("en-GB", {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    trailingZeroDisplay: "stripIfInteger",
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  });
};

export const formatSizes = (descriptors: Descriptor[]) => {
  let formattedSizes: (string | number)[] = [];
  const sortedList: Descriptor[] = [];
  const sizes: (string | number)[] = [];
  descriptors.map((d, index) => {
    if (sizes.includes(d.area)) {
      return;
    }
    sortedList.push(descriptors[index]);
  });
  formattedSizes = getUnitSizes(sortedList);
  return {
    formattedSizes: formattedSizes,
    sortedList: sortedList,
  };
};

export const locationCompanyProfile = () => {
  const company = import.meta.env.VITE_RAPIDSTOR_COMPANY_PROFILE || "SS";
  if (company === "SS") {
    return {
      name: "SureStore",
      "app-store": "https://apps.apple.com/us/app/surestore/id1673189879",
      "google-play":
        "https://play.google.com/store/apps/details?id=com.storapp.app.csbt.ss",
      "phone-number": "08008021050",
    };
  } else {
    return {
      name: "The Self Storage Company",
      "app-store": "https://apps.apple.com/it/app/the-self-storage-company/id1673190223",
      "google-play":
        "https://play.google.com/store/apps/details?id=com.storapp.app.csbt.tssc&hl=en_GB",
      "phone-number": "08008021582",
    };
  }
};
